import { render } from "./SelectFeedbackType.vue?vue&type=template&id=651e32da&ts=true"
import script from "./SelectFeedbackType.vue?vue&type=script&lang=ts"
export * from "./SelectFeedbackType.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__